import { SmopOrderStatusEnum } from "@saleor/types/globalTypes";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";

const StoreOrderSectionUrl = "/store-orders";
export const storeOrderListPath = StoreOrderSectionUrl;

export enum StoreOrderListUrlFiltersEnum {
  createdFrom = "createdFrom",
  createdTo = "createdTo",
  customer = "customer",
  payment = "payment",
  query = "query",
  status = "status",
  shippingFrom = "shippingFrom",
  shippingTo = "shippingTo",
  store = "store",
  runnerFirstName = "runnerFirstName",
  runnerLastName = "runnerLastName"
}
export enum StoreOrderListUrlFiltersWithMultipleValuesEnum {
  deliveryType = "deliveryType",
  verticalType = "verticalType",
  mall = "mall"
}

export type StoreOrderListUrlFilters = Filters<StoreOrderListUrlFiltersEnum> &
  FiltersWithMultipleValues<StoreOrderListUrlFiltersWithMultipleValuesEnum>;
export type StoreOrderListUrlDialog =
  | "cancel"
  | "barcode"
  | TabActionDialog
  | "onOverrideStatus"
  | "onClickSaveButton"
  | "onClickAssignRunner"
  | "generateParcelID";
export enum StoreOrderListUrlSortField {
  date = "date",
  number = "number"
}
export type StoreOrderListUrlSort = Sort<StoreOrderListUrlSortField>;
export type StoreOrderListUrlQueryParams = BulkAction &
  Dialog<StoreOrderListUrlDialog> &
  StoreOrderListUrlFilters &
  StoreOrderListUrlSort &
  Pagination &
  ActiveTab & {
    orderId?: string;
    orderStatus?: SmopOrderStatusEnum;
    newOrderStatus?: SmopOrderStatusEnum;
  } & {
    mall?: string;
  };

export const storeOrderListUrl = (
  params?: StoreOrderListUrlQueryParams
): string => {
  const storeOrderList = storeOrderListPath;
  if (params === undefined) {
    return storeOrderList;
  } else {
    return urlJoin(storeOrderList, "?" + stringifyQs(params));
  }
};

export const storeOrderPath = (id: string) => urlJoin(StoreOrderSectionUrl, id);
export type StoreOrderUrlDialog =
  | "cancel"
  | "onClickStoreOrderProduct"
  | "onClickSaveButton"
  | "onClickAddProduct"
  | "onClickAssignRunner"
  | "onClickEditProduct"
  | "onOverrideStatus"
  | "onReverseCancel";
export interface StoreOrderProductDialog {
  productId?: string;
  productIds?: any;
  orderStatus?: SmopOrderStatusEnum;
}
export type StoreOrderUrlQueryParams = BulkAction &
  Dialog<StoreOrderUrlDialog> &
  StoreOrderProductDialog & {
    mall?: string;
  };
export const storeOrderUrl = (id: string, params?: StoreOrderUrlQueryParams) =>
  storeOrderPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
